import * as React from 'react';

import { connect } from 'react-redux';

import { Dispatch } from 'redux';

import { Form, FormState, FormValues, FormApi } from 'informed';

import { Button } from 'reactstrap';

import { assign as _assign } from 'lodash';

import { 
  ConfigurationModel, 
  ProjectModel,
  UserDataModel,
} from 'franke-trough-dependencies';

import {
  NewProjectFormModel,
  newProjectFormValues,
  InputValue,
  renderFields,
  GlobalPrivateState,
  FormDefaultState,
  formDefaultState,
} from 'src/api';

import { RequestApiResult, RequestApiError, requestAPIActions, RequestApiHttpPayload} from 'loopback-react-request';

import { RouterState } from 'connected-react-router';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ProjectEditForm.messages';

import './ProjectEditForm.scss';
import { userIsInternal, userIsSalesRep } from '../../Admin/utils';
import { UserModel } from 'src/api/models/User';

interface ProjectEditFormProps {
  configuration: RequestApiResult<ConfigurationModel>;
  dispatch: Dispatch;
  location: RouterState['location'];
  project: RequestApiResult<ProjectModel>;
  passedProject?: ProjectModel;
  userData: RequestApiResult<UserDataModel>;
  submitted?: (success: boolean) => void;
  user: RequestApiResult<UserModel>;
}

interface ProjectEditFormState extends FormDefaultState<NewProjectFormModel> {
  loading: boolean;
  requestError?: RequestApiError;
  requestSuccess: boolean;
  submitValues: {[key: string]: InputValue};
  submitted: boolean;
}

// FIXME: use FormHoc
class ProjectEditFormComponent extends React.Component<ProjectEditFormProps, ProjectEditFormState> {
  constructor(props: ProjectEditFormProps) {
    super(props);
    const isInternalUser = this.props.user && (userIsInternal(this.props.user.result) || userIsSalesRep(this.props.user.result));

    this.state = {
      formFields: newProjectFormValues(isInternalUser),
      formHasErrors: true,
      formState: formDefaultState,
      loading: false,
      requestSuccess: false,
      submitValues: {},
      submitted: false,
    };
    
    this.getFormApi = this.getFormApi.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePreSubmit = this.handlePreSubmit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidUpdate(prevProps: ProjectEditFormProps) {    
    const {project, userData, submitted, user} = this.props;
    const {loading, formFields, formApi} = this.state;
    
    if (user.result && user.loaded && !user.updating && JSON.stringify(prevProps.user.result) !== JSON.stringify(user.result)) {
      const isInternalUser = this.props.user && (userIsInternal(this.props.user.result) || userIsSalesRep(this.props.user.result));
      
      this.setState({
        formFields: newProjectFormValues(isInternalUser)
      });
    }

    if (project.updating && !loading) {
      this.setState({loading: true});
    }

    if (project.result && loading) {
      if (project.result && !project.updating && project.loaded) {
        this.props.dispatch(requestAPIActions.loadCleared('project'));
        if (submitted) {
          submitted(true);
        }
        if (userData && userData.result) {
          this.props.dispatch(requestAPIActions.load(
            'projects', {
              url: `/UserData/${userData.result && userData.result.id}/Projects`
            },
            true
          ));
        }
        // Populate formFelds
        this.setState({
          requestSuccess: true,
          loading: false
        });
      }
    }
    if (project.error && loading) {
      if (formApi && formFields) {
        const values = {};
        Object.keys(formFields).map(key => _assign(values, {[key]: formFields[key].value}));
        formApi.setValues(values);
      }
      this.setState({
        requestError: project.error,
        loading: false,
      });
      if (submitted) {
        submitted(false);
      }
    }
  }

  render() {
    const { user } = this.props;
    const { formFields, formHasErrors, requestError, formState } = this.state; 
    
    return (
      <div className="partial-project-form my-0 mx-auto mb-5">
        <Form
          getApi={this.getFormApi}
          initialValues={this.initialValues || formState.values}
          onSubmit={this.handleSubmit} 
          onChange={this.handleChange}
        >
          {({formState}) => (
            <div>
              <div className="row m-0">
                <div className="col-12">
                  {requestError && (
                    <p className="text-danger">
                      {requestError.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="row m-0">
                {formFields && Object.keys(formFields).map((fieldKey: string, index: number) => {
                  const key = `form_field_${fieldKey}_${index}`;
                  const field = formFields[fieldKey];
                  field.disabled = this.props.project.updating;
                  
                  // field.name field.value... 
                  return (
                    <div key={key} className={field.col ? `col-12 col-sm-${field.col}` : 'col-12'}>
                      {renderFields<NewProjectFormModel>({
                        field: field,
                        formState,
                        index: fieldKey,
                      })}
                    </div>
                  );
                })}
              </div>
              <div className="row m-0">
                <div className="col-12 text-center">
                  <Button
                    className="register-button mt-3" 
                    type="submit"
                    disabled={formHasErrors}
                  >
                    <FormattedMessage {...MESSAGES.projectsEditFormButton} />
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Form>
      </div>
    );
  }

  private getFormApi(formApi: FormApi<FormValues>) {
    this.setState({formApi});
  }

  private handleChange(formState: FormState<FormValues>) {
    if (!this.state.formApi) {
      return;
    }
    
    // const formState = this.state.formApi.getState();
    const {errors} = formState;
    const errorKeys = errors && Object.keys(errors);
    const formHasErrors = errorKeys && errorKeys.length > 0 ? true : false;
   
    this.setState({
      formState,
      formHasErrors,
      formErrors: !formState.pristine ? formState.errors : {},
    });
  }

  private handlePreSubmit(values: FormValues): FormValues {
    const {
    } = this.props;

    const { 
      formState, 
      formFields,
      submitValues, 
    } = this.state;

    _assign(submitValues, values);

    if (formFields) {
      Object.keys(formFields).map(key => formFields[key].value = values[key]);
    }

    if (values.id) {
      delete values.id;
    }
    if (values.userId) {
      delete values.userId;
    }
    if (values.userdataId) {
      delete values.userdataId;
    }
    if (values.created_at) {
      delete values.created_at;
    }
    if (values.updated_at) {
      delete values.updated_at;
    }

    this.setState({
      formState,
      submitValues,
    });

    return values;
  }

  private get initialValues(): FormValues | undefined {
    const project = this.props.passedProject || this.props.project && this.props.project.result;

    if (!project) {
      return;
    }

    const {
      formFields,
      formState
    } = this.state;

    if (formFields && formState) {

      // submitValues

      const initialValues: FormValues | {} = {};
      const formFieldKeys = Object.keys(formFields);
      
      Object.keys(project).forEach(key => {
        if (formFieldKeys.indexOf(key) > -1) {          
          initialValues[key] = project[key];
        }
      });
      return initialValues as FormValues;
    }

    return;
  }

  private handleSubmit(values: FormValues): void {
    const {formHasErrors} = this.state;
    if (!formHasErrors) {
      this.dispatchRegister(values);
    }
  }

  private dispatchRegister(values: FormValues) {
    const { submitValues, formApi } = this.state;
    const { userData, passedProject } = this.props;
    const project = this.props.project.result || passedProject
    if (userData && userData.result) {
      if (formApi) {
        const valuesToSet = submitValues as FormValues;
        formApi.setValues(valuesToSet);
      }

      const valuesToDispatch = this.handlePreSubmit(values);
      
      this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>(
        'project', {
          url: `/Projects/${project && project.id}`,
          options: {
            method: 'PATCH',
            data: valuesToDispatch,
          },
        },
        true
      ));
      
      this.setState({
        submitted: true,
        formHasErrors: false,
      });
    }
  }

}

export const ProjectEditForm = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  location: state.router.location,
  project: state.project,
  userData: state.userData,
  user: state.user,
}))(ProjectEditFormComponent);

